export default "__VITE_ASSET__55445d59__"